import { TyreSeason } from './tyre.season';

export class TyreSearchInfo {
    Seasons: TyreSeason[];
    Brands: string[];
    Widths: number[];
    AspectRatios: number[];
    Diameters: number[];
}
